function digitsOnly(input: string): string {
	return input.replace(/\D/g, '');
}

type ParsedPhone = { country: 'ru' | 'uz' | 'other'; e164: string };

function parsePhone(raw: string): ParsedPhone | null {
	const trimmed = raw.trim();
	if (!trimmed) return null;

	const d = digitsOnly(trimmed);
	if (!d) return null;

	if (d.length === 11 && (d.startsWith('7') || d.startsWith('8'))) {
		const national = d.startsWith('8') ? d.slice(1) : d.slice(1);
		return { country: 'ru', e164: `+7${national}` };
	}

	if (d.length === 10 && d.startsWith('9')) {
		return { country: 'ru', e164: `+7${d}` };
	}

	if (d.length === 12 && d.startsWith('998')) {
		return { country: 'uz', e164: `+${d}` };
	}

	if (d.length === 9) {
		return { country: 'uz', e164: `+998${d}` };
	}

	return { country: 'other', e164: `+${d}` };
}

export function normalizePhoneForCopy(raw: string): string {
	const parsed = parsePhone(raw);
	if (parsed) return parsed.e164;
	return raw.trim();
}

export function formatPhoneDisplay(raw: string | null | undefined): string {
	if (raw == null || !raw.trim()) return '—';

	const parsed = parsePhone(raw);
	if (!parsed) return raw.trim();

	if (parsed.country === 'ru') {
		const national = parsed.e164.slice(2);
		return `+7 (${national.slice(0, 3)}) ${national.slice(3, 6)}-${national.slice(6, 8)}-${national.slice(8, 10)}`;
	}

	if (parsed.country === 'uz') {
		const national = parsed.e164.slice(4);
		return `+998 (${national.slice(0, 2)}) ${national.slice(2, 5)}-${national.slice(5, 7)}-${national.slice(7, 9)}`;
	}

	return parsed.e164;
}

export function phoneDigitsForSearch(raw: string): string {
	return digitsOnly(raw);
}

export function phoneMatchesQuery(raw: string | null | undefined, query: string): boolean {
	if (!raw?.trim() || !query.trim()) return false;
	const haystack = phoneDigitsForSearch(raw);
	const needle = phoneDigitsForSearch(query);
	return haystack.includes(needle);
}
